import { z } from 'zod';

import zodLocales from 'common/zod/locales';

export const searchSchema = z
  .object({
    recipientEmail: z
      .string()
      .min(1, {
        message: zodLocales.errors.required,
      })
      .email({
        message: zodLocales.errors.invalidEmail,
      })
      .optional(),
    shouldNotifyRecipient: z.boolean().default(false),
  })
  .refine(
    ({ recipientEmail, shouldNotifyRecipient }) => {
      if (!shouldNotifyRecipient) {
        return true;
      }

      return !!recipientEmail;
    },
    {
      message: zodLocales.errors.required,
      path: ['recipientEmail'],
    },
  );

export type ApproveFormRequestSchema = z.infer<typeof searchSchema>;
